import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import HomeContainer from './views/HomeContainer.vue';
// import Map from './views/Map/Detail.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'homeContainer',
      component: HomeContainer,
      redirect: '/#',
      children: [
        {
          path: '/#',
          name: 'home',
          component: Home,
        },
        {
          path: '/book',
          name: 'book',
          component: () => import('./views/Book/Index.vue'),
        },
        {
          path: '/file',
          name: 'file',
          component: () =>  import('./views/File/Index.vue'),
        },
        {
          path: '/timeline',
          name: 'Timeline',
          component: () => import('./views/Timeline/Index.vue'),
        },
        {
          path: '/map',
          name: 'Map',
          component: () =>  import('./views/Map/Index.vue'), // Map,
        },
        {
          path: '/mapdetail',
          name: 'MapDetail',
          component: () =>  import('./views/Map/Detail.vue'), // Map,
        },
        {
          path: '/literature',
          name: 'Literature',
          component: () =>  import('./views/Literature/Index.vue'), // Map,
        },
        {
          path: '/literaturedetail',
          name: 'LiteratureDetail',
          component: () =>  import('./views/Literature/Detail.vue'), // Map,
        },
        {
          path: '/charts',
          name: 'Charts',
          component: () =>  import('./views/Charts/Index.vue'), // Map,
        },
        {
          path: '/chartsdetail',
          name: 'ChartsDetail',
          component: () =>  import('./views/Charts/Detail.vue'), // Map,
        },
        {
          path: '/favorite',
          name: 'Favorite',
          component: () =>  import('./views/Favorite/Index.vue'), // Map,
        },
        {
          path: '/user',
          name: 'userContainer',
          component: () => import('./views/User/UserContainer.vue'),
          children: [
            {
              path: 'password',
              name: 'Password',
              component: () => import('./views/User/Password.vue'),
            },
            {
              path: 'userlist',
              name: 'UserList',
              component: () => import('./views/School/UserList.vue'),
            },
            {
              path: 'schooldetail',
              name: 'SchoolDetail',
              component: () => import('./views/School/Detail.vue'),
            },
          ],
        },
      ],
    },
    {
      path: '/blank',
      name: 'blank',
      component: () => import('./views/Blank.vue'),
      children: [
        {
          path: 'timelinedetail',
          name: 'TimelineDetail',
          component: () => import('./views/Timeline/detail.vue'),
        },
      ],
    },
    
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
  ],
});
